import { GridValidRowModel } from "@mui/x-data-grid";
import { switchGroup } from "src/api/contractSweepRecipientSetting";
import DialogInOne, { DialogInOneProps } from "src/components/DialogInOne";
import { useAssets } from "src/components/FetchConfig";
import Prompter from "src/components/Prompter";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { useAlerting, useTranslation, useYubiPrompt } from "src/hooks";
import { useZusDialogStore } from "src/zustand/store";
import { GetListRes } from "../types/GetListRes";

type Props = {
  isOpen: boolean;
  selectedRow: (GridValidRowModel & { rawData: GetListRes }) | undefined;
  onClose: () => void;
};

const useSwitchGroupDialog = (props: Props) => {
  const { isOpen, selectedRow, onClose } = props;
  const { rawData } = selectedRow || {};

  const { getResAfterYubi, prompterConfig } = useYubiPrompt();
  const zusDialog = useZusDialogStore();
  const { translatePrefix, onFilterSearch } = usePageConfigProviderContext();
  const { t } = useTranslation(translatePrefix);
  const { alerting } = useAlerting();
  const { selectAssetsByChain } = useAssets();

  const assets = selectAssetsByChain({
    chain_type: rawData?.chain_type,
    chain_id: rawData?.chain_id,
  });
  const selectedAsset = assets.find(
    (item) => item.asset_name === rawData?.asset_name,
  );

  const onConfirm = async () => {
    zusDialog.openExtra("loadingDialog");
    const res: any = await getResAfterYubi(switchGroup, {
      chainType: rawData?.chain_type,
      chainId: rawData?.chain_id,
      assetName: rawData?.asset_name,
      groupId: rawData?.id,
      groupSeq: rawData?.group_seq,
      groupType: rawData?.chain_type,
      decimals: selectedAsset?.decimals,
      status: rawData?.status,
    });
    zusDialog.closeExtra();
    if (res) {
      alerting("success", t("edit_record_success"));
      onFilterSearch();
      onClose();
    }
  };

  const dialogInOne: DialogInOneProps = {
    title: t("switch_group"),
    self: {
      open: isOpen,
      onClose: onClose,
    },
    content: <>{t("confirm_to_switch_on")}</>,
    onConfirm: onConfirm,
    onCancel: onClose,
  };

  const renderSwitchGroupDialog = () => {
    return (
      <>
        <Prompter {...prompterConfig} />
        <DialogInOne {...dialogInOne} />
      </>
    );
  };

  return { renderSwitchGroupDialog };
};
export default useSwitchGroupDialog;
